import React, { PropsWithChildren } from 'react';

import Button from '../button/button';

type Mode = 'default' | 'fullHeight';

type BackdropProps = {
  className?: string;
  resetSearch?: () => void;
  handleOpen: () => void;
  clearAllString?: string;
  showResultsString?: string;
  showButtons?: boolean;
  filteredCardsCount?: number;
  mode?: Mode;
};

const Backdrop = ({
  className,
  resetSearch,
  children,
  handleOpen,
  clearAllString,
  showResultsString,
  showButtons = true,
  filteredCardsCount,
  mode = 'default',
}: PropsWithChildren<BackdropProps>) => {
  const heightClasses = (mode: Mode) => {
    switch (mode) {
      case 'fullHeight':
        return ' max-h-full rounded-t-none ';
      case 'default':
        return ' max-h-[87%] sm:max-h-[35%] rounded-t-xxl ';
      default:
        break;
    }
  };
  return (
    <div
      className={`fixed bottom-0 left-0 z-50 flex h-auto min-h-[350px] sm:min-h-[190px] w-full flex-col items-center justify-between bg-background-primary-light bg-dynamicStrokeGrey bg-cover bg-top bg-no-repeat shadow-default transition-all duration-300 ease-out ${heightClasses(
        mode,
      )} ${className}`}
    >
      <div
        className={`sticky top-0 z-50 flex h-full w-full flex-col items-center justify-between px-10 ${
          mode === 'fullHeight' ? ' px-6 py-6' : ' px-10 py-12 sm:py-8'
        }`}
      >
        <div className="h-auto w-full ">{children}</div>
      </div>
      {showButtons && (
        <div className="mb-8 flex h-auto w-10/12 items-center justify-evenly ">
          <Button className="z-50" variant="secondary" onClick={resetSearch}>
            {clearAllString}
          </Button>
          <Button variant="primary" className="z-50" onClick={handleOpen}>
            {showResultsString} ({filteredCardsCount})
          </Button>
        </div>
      )}
    </div>
  );
};

export default Backdrop;
